<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-save-snippet");

    export let saveFunction;
    export let saveSuccessFunction;
    export let preview;

    let saveTitle;
    let saveReady;
    let saving;

    const pattern = /^[a-zA-Z0-9\s\.\-\p{L}]+$/u;
    $: nameValid = !saveTitle || pattern.test(saveTitle)
    $: saveReady = Boolean(saveTitle && nameValid && saveTitle.length > 0);

    let saveError;

    export function open() {
        //manage focus
        jQuery('#GPSaveSnippet').on('show.bs.modal', GP.storeFocus);
        jQuery('#GPSaveSnippet').on('shown.bs.modal',function (){jQuery('#GPSaveSnippetTitle').focus()});
        jQuery('#GPSaveSnippet').on('hidden.bs.modal', GP.restoreFocus);

        //trap focus
        jQuery('#GPSaveSnippet .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPSaveSnippet #GPSaveSnippetConfirm').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});

        saving = false;
        saveError = false;

        jQuery('#GPSaveSnippet').modal({});
        jQuery('#GPSaveSnippet').on('hidden.bs.modal', () => this.$destroy());
    }
    
    function saveConfirmed () {
        if (!saveReady) return false;

        saving = true;
        saveError = false;

        saveFunction(saveTitle)
            .then((res) => {
                jQuery('#GPSaveSnippet').modal('hide');
                saveSuccessFunction(res);
            })
            .catch(() => {saveError = true; saving = false;});
        return false;
    }

    
</script>

<div class="modal fade GPModal" id="GPSaveSnippet">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Save plant arrangement")}</h4>
            </div>
            <div class="modal-body">
                <div class="GPSaveSnippetPreview">
                    <img src="{preview}"/>
                </div>
                <div class="form-group">
                    <label class="control-label" for="GPSaveSnippetTitle">{trans("Arrangement name")}: </label>
                    <input class="form-control" placeholder='{trans("Untitled")}' type="text" id="GPSaveSnippetTitle" name="gpsavetitle" bind:value={saveTitle} required>
                </div>
                {#if !nameValid}
                    <div class="form-group">
                        <span id="helpBlock" class="help-block">{trans( "Please enter a nice name with letters and numbers only")+"!"}</span>
                    </div>
                {/if}
                {#if saveError}
                    <div class="form-group">
                        <span class="help-block error-message">{trans( "Problem with saving - check your internet connection and retry")+"."}</span>
                    </div>
                {/if}
                <div class="form-group">
                    <button class="btn btn-default {(saveReady && !saving)?'':'disabled'}" id="GPSaveSnippetConfirm" on:click={saveConfirmed}>{trans("Save")}
                        {#if saving}<i class="button-waiting fa fa-spin fa-spinner" style="display: inline-block"></i>{/if}
                    </button>
                </div>
            </div>
            <div class="modal-footer">
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->       